import { DataService } from '../../services/data_service';
import { findGTZOrt } from '../../bereiche/dateneingabe/functions/findGTZOrt';
import { getOrt } from '../../helpers/getOrt';
import { IDs } from '../../helpers/IDs';
import { TriggerService } from '../../core/trigger/trigger_service';

const cacheSearch: any = {};
const MAPBOX_TOKEN = 'pk.eyJ1Ijoib2xpdmVyYnVuZGEiLCJhIjoiY2s1bWt2djVzMHhvOTNucGNzZXhrdWFuOSJ9.msxL5i1GigS33y-i3OtYMQ';

export function processWetterstationen(data: any, triggerService: TriggerService): void {
    if (!Object.keys(data || {}).length) {
        return;
    }
    const gtz_orte: Array<any> = (data[IDs.ENT_GTZ_ORTE] || []).filter((ort: any) => (+ort.ungueltig || 0) !== 1);

    const process = (orte: Array<any>, index: number, save: Array<any>, ready: (data: Array<any>) => void): void => {
        const len: number = (orte || []).length;

        if (!len || index >= len) {
            if (typeof ready === 'function') {
                ready(save);
            }
            return;
        }
        const ort: any = orte[index] || {};
        const ort_gtz: string = ort.ort_gtz || null;
        const plz: string = ort.plz || null;

        if (((plz || '').length === 5) && getOrt(plz) && !gtz_orte.some((ort: any) => (ort.ort || null) === ort_gtz)) {
            getWetterstation(plz, data, (result: string) => {
                if (typeof result === 'string') {
                    save.push({ tid: ort.tid, ort_gtz: result });
                }
                process(orte, ++index, save, ready);
            });
        } else {
            process(orte, ++index, save, ready);
        }
    };
    process(
        data[IDs.ENT_UNTERNEHMENSDATEN] || [], 0, [],
        (save: Array<any>) => setWetterstationen(save, IDs.ENT_UNTERNEHMENSDATEN, triggerService)
    );
    process(
        data[IDs.ENT_STANDORT] || [], 0, [],
        (save: Array<any>) => setWetterstationen(save, IDs.ENT_STANDORT, triggerService)
    );
}

function getWetterstation(search: string, data: any, callback: (data: string) => void): void {
    console.log('Get Wetterstation: ', search);
    if (typeof search !== 'string') {
        if (typeof callback === 'function') {
            callback(null);
        }
        return;
    }

    if (typeof cacheSearch[search] !== 'undefined') {
        if (typeof callback === 'function') {
            callback(cacheSearch[search]);
        }
        return;
    }
    const url: string = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(search)}.json?country=DE&limit=5&language=de&access_token=${MAPBOX_TOKEN}`;
    fetch(url)
        .then(response => response.json())
        .then(json => {
            console.log('Checking for match...');
            const center: any = (((json || {}).features || [])[0] || {}).center || {};
            const lat = center[1] || null;
            const lon = center[0] || null;

            if (lat !== null && lon !== null) {
                const ort: string = (findGTZOrt(data, lat, lon, true) || {}).ort || null;
                cacheSearch[search] = ort;
                console.log('GTZ-ORT-MATCH: ', lat, lon, ort);
                if (typeof callback === 'function') {
                    callback(ort);
                }
            }
        })
        .catch(() => {
            cacheSearch[search] = null;

            if (typeof callback === 'function') {
                callback(null);
            }
        });
}

function setWetterstationen(data: Array<any>, entity: string, triggerService: TriggerService): void {
    if (!(data || []).length) {
        return;
    }
    new DataService().saveDataList(
        entity, data,
        () => triggerService.fire('reload', entity),
        IDs.MOD_ETOOL
    );
}
